// removed by extract-text-webpack-plugin
module.exports = {"logoLink":"T8qBWtbmZPhEvQCJHdE3","logoSmall":"_3AJTBQWTR3Uajogd8ivLuN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LogoLink/LogoLink.scss
// module id = 1636
// module chunks = 0